import { Bets } from '../../../config';
import { useGameSelector } from '../../GameStore';

export const useBetStepperSlice = {
  getBetInputValue: (): Record<number, string> => {
    return useGameSelector(({ betStepper }) => betStepper.betInputValues);
  },
  getLastBetInputValue: (betCode: Bets): string => {
    return useGameSelector(({ betStepper }) => betStepper.lastBetInputValues[betCode]);
  },
  isBetFinalized: (betCode: Bets): boolean => {
    return useGameSelector(({ betStepper }) => betStepper.isBetFinalized[betCode]);
  },
  getBetInputStack: (betCode: Bets): string[] => {
    return useGameSelector(({ betStepper }) => betStepper.betInputStack[betCode].stack);
  },
  quickBetClick: (): Record<string, { click: boolean; count: number }> => {
    return useGameSelector(({ betStepper }) => betStepper.quickBetClickedOn);
  },
};
